import React from 'react'
import ButtonBuyQuantity from '../UI/button/ButtonBuyQuantity'
import { useDispatch, useSelector } from 'react-redux'
import {
    setQuantitySort,
    setDeliverySort,
    setPriceSort,
    selectSort,
    selectQuantitySort,
    selectDeliverySort,
    selectPriceSort
} from './sortSlice'
import isProd from '../../utils/constants/isProd'
import getSortSymbol from '../../utils/sort/getSortSymbol'
import _ from 'lodash'
import { selectPartsInBasket } from './partsInBasketSlice'
import isAuthorized from '../../utils/constants/isAuthorized'
import InfoStar from '../notepad/InfoStar'
import searchParams from '../../utils/constants/searchParams'
import parseStyles from '../../utils/helpers/parseStyles'
import { analogType, sphinxType } from '../../utils/constants/partGroupes'
import { isMobile } from 'react-device-detect'

const ResultTableFlat = ({ parts, title, type }) => {
    const dispatch = useDispatch()
    const sort = useSelector(selectSort)

    const quantitySort = useSelector(selectQuantitySort)
    const quantitySortOrder = quantitySort[type]
    const quantitySortSymbol = getSortSymbol(quantitySortOrder)

    const deliverySort = useSelector(selectDeliverySort)
    const deliverySortOrder = deliverySort[type]
    const deliverySortSymbol = getSortSymbol(deliverySortOrder)

    const priceSort = useSelector(selectPriceSort)
    const priceSortOrder = priceSort[type]
    const priceSortSymbol = getSortSymbol(priceSortOrder)

    const partsInBasket = useSelector(selectPartsInBasket)

    return (
        <div className="result-group">
            {!isProd && (
                <div>
                    <div>Sort:</div>
                    <pre>
                        <code>{JSON.stringify(sort[type], null, 2)}</code>
                    </pre>
                </div>
            )}
            <h2 className="result-group__title">{title}</h2>
            <div className="result-table result-table-flat">
                <div className="result-table__header">
                    <div className="result-table__header-cell brand">
                        <span>Бренд</span>
                    </div>
                    <div className="result-table__header-cell article">
                        <span>Артикул</span>
                    </div>
                    <div className="result-table__header-cell description">
                        <span>Наименование</span>
                    </div>
                    {isAuthorized && (
                        <div className="result-table__header-cell supplier">
                            <span>Поставщик</span>
                        </div>
                    )}
                    <div className="result-table__header-cell in-stock">
                        <span onClick={() => dispatch(setQuantitySort({ type }))}>
                            Наличие, шт. {quantitySortSymbol}
                        </span>
                    </div>
                    <div className="result-table__header-cell delivery">
                        <span onClick={() => dispatch(setDeliverySort({ type }))}>
                            Срок {deliverySortSymbol}
                        </span>
                    </div>
                    {/*<div className="result-table__header-cell tag"></div>*/}
                    <div className="result-table__header-cell price">
                        <span onClick={() => dispatch(setPriceSort({ type }))}>
                            Цена {priceSortSymbol}
                        </span>
                    </div>
                    <div className="result-table__header-cell action">
                        <span>К-во, шт.</span>
                    </div>
                </div>
                <div className="result-table__body">
                    <div className="result-table__parts">
                        {parts.map((part, index) => (
                            <div
                                className="result-table__part"
                                style={parseStyles(searchParams['SUPPLIERS_CSS'][part.supplier_id])}
                                key={part.hash}
                            >
                                <div className="result-table__part-cell brand">
                                    <InfoStar part_id={part.id} hash={part.notepad_hash} />
                                    <span className="result-table__info-brand">
                                        <span className="turncate" data-text={part.brand_title}>
                                            {part.brand_title}
                                        </span>
                                    </span>
                                </div>
                                <div className="result-table__part-cell article">
                                    {isAuthorized &&
                                    (type === analogType || type === sphinxType) ? (
                                        <a
                                            className="result-table__info-article"
                                            data-text={part.original_article}
                                            href={`/auto/search/${encodeURIComponent(
                                                part.original_article
                                            )}/?brand_title=${encodeURIComponent(
                                                part.brand_title
                                            )}`}
                                        >
                                            {/*<span*/}
                                            {/*className="turncate"*/}
                                            {/*data-text={part.original_article}*/}
                                            {/*>*/}
                                            {part.original_article}
                                            {/*</span>*/}
                                        </a>
                                    ) : (
                                        <span className="result-table__info-article">
                                            <span
                                                className="turncate"
                                                data-text={part.original_article}
                                            >
                                                {part.original_article}
                                            </span>
                                        </span>
                                    )}
                                </div>
                                <div className="result-table__part-cell description">
                                    <span className="turncate" data-text={part.title}>
                                        {part.title}
                                    </span>
                                </div>
                                <div className="hr"> </div>
                                {searchParams['NOT_AVAILABLE_SUPPLIERS'].includes(
                                    part['supplier_id']
                                ) ? (
                                    <div className="result-table__part-cell not-available">
                                        {searchParams['TEXT_NOT_AVAILABLE_SUPPLIERS']}
                                    </div>
                                ) : (
                                    <>
                                        {isAuthorized && (
                                            <div className="result-table__part-cell supplier">
                                                <span
                                                    className="turncate"
                                                    data-text={part.supplier_title}
                                                >
                                                    {part.supplier_title}
                                                </span>
                                            </div>
                                        )}
                                        <div className="result-table__part-cell in-stock">
                                            {isAuthorized
                                                ? part.quantity
                                                : part.quantity > 10
                                                ? '>10'
                                                : part.quantity}
                                        </div>
                                        <div className="result-table__part-cell delivery">
                                            {part.supplier_id === "35"
                                                ? <span data-tip data-for="tooltip_delivery">в пути</span>
                                                : part.delivery_time}
                                        </div>
                                        <div className="result-table__part-cell price">
                                            {part.kentek_price_type === 'price_20' && (
                                                <span className="part-tag-sale">%</span>
                                            )}
                                            {part.price_src <= 0 ? (
                                                isMobile ? (
                                                    'Узнать'
                                                ) : (
                                                    <span
                                                        data-tip
                                                        data-for="tooltip_part_zero_price"
                                                    >
                                                        Узнать
                                                    </span>
                                                )
                                            ) : (
                                                part.price
                                            )}
                                        </div>
                                        <div className="result-table__part-cell action">
                                            <ButtonBuyQuantity
                                                part={part}
                                                basketInfo={
                                                    _.has(partsInBasket, [part.basket_hash])
                                                        ? partsInBasket[part.basket_hash]
                                                        : 0
                                                }
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResultTableFlat
